import {
  BOOKING_DIRECTIONS_MULTIPLIER,
  DirectionEnum,
  IDropdownItemShifts,
} from "@ryde/shared";

export const isMealOnlyShiftSelected = ({
  shiftDropdownItems,
  shiftId,
}: {
  shiftDropdownItems: IDropdownItemShifts[];
  shiftId?: number | null;
}): boolean => {
  if (shiftId === undefined || shiftId === null) {
    return false;
  }

  const selectedShift = shiftDropdownItems.find(item => item.value === shiftId);

  return Boolean(selectedShift?.isMealOnly);
};

/**
 * How many bookings one passenger row is shown as creating. Display only — the payload is unchanged.
 * RYDE-8171: the backend collapses a meal-only shift row (even an AB one) into a single direction X booking.
 */
export const getBulkBookingDirectionMultiplier = ({
  direction,
  isMealOnlyShift,
}: {
  direction?: DirectionEnum;
  isMealOnlyShift: boolean;
}): number => {
  if (isMealOnlyShift || direction !== DirectionEnum.Both) {
    return 1;
  }

  return BOOKING_DIRECTIONS_MULTIPLIER;
};
